import React from "react"

import { MFC_OPERATOR, BC_OPERATOR, MC_OPERATOR, operators } from "utils/constants"

const SubdomainContext = React.createContext({
    currentSubdomain: null,
    getSubdomain: () => { }
})

const useSubdomain = () => React.useContext(SubdomainContext)

const favicon = document.getElementById("favicon")

const SubdomainProvider = ({ children }) => {
    const [currentSubdomain, setCurrentSubdomain] = React.useState(null)

    const getCorrespondingOperator = (idApi) => {
        return operators?.find(o => o.id_api === idApi) || {}
    }

    const getSubdomain = () => {
        const subdomain = document.domain.split(".")
        //if (subdomain.includes("pro")) return { ...getCorrespondingOperator(BC_OPERATOR), registrationWithG8: true }
        if (subdomain.includes("bicycode")) return { ...getCorrespondingOperator(BC_OPERATOR), registrationWithG8: true }
        if (subdomain.includes("mfc")) return { ...getCorrespondingOperator(MFC_OPERATOR) }
        if (subdomain.includes("moustache")) return { ...getCorrespondingOperator(MC_OPERATOR) }
        // TODO: create theme for O°Code
        else return { id: "ocode", id_api: "OC" }
    }

    React.useEffect(() => {
        const subdomain = getSubdomain()
        setCurrentSubdomain(subdomain)

        // set new favicon 
        if (subdomain.id_api === BC_OPERATOR) {
            document.body.classList.add(subdomain.id)
            favicon.href = process.env.PUBLIC_URL + "/favicon-bicycode.png"
        }
        else if (subdomain.id_api === MFC_OPERATOR) {
            document.body.classList.add(subdomain.id)
            favicon.href = process.env.PUBLIC_URL + "/favicon-mfc.png"
        }
        else if (subdomain.id_api === MC_OPERATOR) {
            document.body.classList.add(subdomain.id)
            favicon.href = process.env.PUBLIC_URL + "/favicon-moustache.png"
        }
        else {
            favicon.href = process.env.PUBLIC_URL + "/favicon.png"
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <SubdomainContext.Provider value={{ currentSubdomain, getSubdomain }}>
            {children}
        </SubdomainContext.Provider>
    )
}

export { useSubdomain, SubdomainProvider }